export default {
    employeeMamagement: 'Employee Management',
    searchBy: 'Search by Employee No or Name',
    search: 'Search',
    allStatus: 'All Status',
    allEmployment: 'All Employment',
    name: 'Full Name',
    contact: 'Contact',
    contactNo: 'Contact No.',
    group: 'Group',
    department: 'Department',
    status: 'Status',
    line: 'Line',
    employeeFace: 'Face Image',
    action: 'Action',
    import: 'Import',
    active: 'Active',
    deactive: 'Deactive',
    createNewEmployee: 'Create New Employee',
    export: 'Export',
    deleteEmployee: 'Delete Employee',
    congratulation: 'Congratulation',
    msgDeleteSuccess: 'Employee is deleted.',
    questionDelete: 'Are you sure to delete "$Name"?',
    allFaceStatus: 'All Face Status',
    validFaceImage: 'Valid Face Image',
    inValidFaceImage: 'Invalid Face Image'
}
